/* eslint-disable react/require-default-props */
import { Box, VStack } from '@chakra-ui/core';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { RequisitionHeader } from './RequisitionHeader';
// import { ComparisionTable } from './sections/ComparisionTable';
import { ContractedHours } from './sections/ContractedHours';
import { FlexibilityRequirement } from './sections/FlexibilityRequirement';
import { RequisitionNotes } from './sections/RequisitionNotes';
import { ShiftSchedule } from './sections/ShiftSchedule';
import { RequisitionDetailViewModel } from './utils/RequisitionDetailsViewModel';
import colors from '../../../../styles/colors';

interface RequisitionDetailsContentProps {
  viewModel: RequisitionDetailViewModel | undefined;
  showHeader?: boolean;
}

export const RequisitionDetailsContent = memo(({ viewModel, showHeader = true }: RequisitionDetailsContentProps) => {
  const { t } = useTranslation('requisition');

  if (!viewModel) {
    return (
      <Box fontSize="16px" fontWeight={700} data-testid="error-message">
        {t('couldNotLoadRequisition')}
      </Box>
    );
  }

  return (
    <VStack justify="space-between" align="stretch" spacing={6} w="full">
      {showHeader && (
        <RequisitionHeader
          requisitionId={viewModel.requisitionId}
          statusLabel={viewModel.statusLabel}
          statusColorScheme={viewModel.statusColorScheme}
          isFullTime={viewModel.isFullTime}
          isSeasonal={viewModel.isSeasonal}
          partTimeHoursLabel={viewModel.partTimeHoursLabel}
          wageLabel={viewModel.wageLabel}
          effectiveDateLabel={viewModel.effectiveDateLabel}
          seasonalEndDateLabel={viewModel.seasonalEndDateLabel}
        />
      )}
      <Box w="full">
        <VStack
          align="stretch"
          p={3}
          borderRadius="md"
          borderWidth="1px"
          borderColor={colors.table.borderColor}
          bg={colors.requisitionDetails.cardBg}
        >
          {viewModel.flexibility && <FlexibilityRequirement flexibility={viewModel.flexibility} />}
          {viewModel.shiftSchedule && <ShiftSchedule shiftSchedule={viewModel.shiftSchedule} />}
        </VStack>
      </Box>
      <ContractedHours contractedHours={viewModel.contractedHours} />

      {/* {shouldCompare && viewModel.comparison && <ComparisionTable comparison={viewModel.comparison} />} */}

      <RequisitionNotes note={viewModel.note} />
    </VStack>
  );
});

RequisitionDetailsContent.displayName = 'RequisitionDetailsContent';
